"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlagOptions = exports.ArrowDown = exports.CountryLabel = exports.CountryFlag = exports.FlagImage = exports.SelectFlagOption = exports.FlagSelect = exports.Wrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 999999;\n  border: 1px solid #bdbbbb;\n  border-radius: 3px;\n  background: #ffffff;\n  margin-top: 8px;\n  padding: 10px 15px;\n  width: 100%;\n  height: 140px;\n  left: 0;\n  overflow: auto;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  color: #4d4d4d;\n  cursor: pointer;\n  padding: 4px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  padding-left: 5px;\n  font-family: Sofia Pro;\n  font-size: 13px;\n  position: relative;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  font-size: 1em;\n  position: relative;\n  cursor: pointer;\n  height: 16px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: ", "\n  height: 1.3em;\n  position: relative;\n  top: 0.3em;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  cursor: pointer;\n  justify-content: space-between;\n  outline: none;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: #4d4d4d;\n  border: 1px solid #d9dfea;\n  border-radius: 3px;\n  padding: 4px 18px;\n  background-color: #ffffff;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents["default"].div(_templateObject());

exports.Wrapper = Wrapper;

var FlagSelect = _styledComponents["default"].div(_templateObject2());

exports.FlagSelect = FlagSelect;

var SelectFlagOption = _styledComponents["default"].div(_templateObject3());

exports.SelectFlagOption = SelectFlagOption;

var FlagImage = _styledComponents["default"].img(_templateObject4(), function (props) {
  return props.flagWidth ? props.flagWidth : '1.2em';
});

exports.FlagImage = FlagImage;

var CountryFlag = _styledComponents["default"].span(_templateObject5());

exports.CountryFlag = CountryFlag;

var CountryLabel = _styledComponents["default"].span(_templateObject6());

exports.CountryLabel = CountryLabel;

var ArrowDown = _styledComponents["default"].div(_templateObject7());

exports.ArrowDown = ArrowDown;

var FlagOptions = _styledComponents["default"].div(_templateObject8());

exports.FlagOptions = FlagOptions;